// Variáveis públicas (embutidas no JavaScript do site). Nunca coloque segredos aqui:
// tudo que começa com VITE_ fica visível para qualquer visitante.

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Variável de ambiente ausente: ${name}. Veja .env.example.`)
  }
  return value
}

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabasePublishableKey: required(
    'VITE_SUPABASE_PUBLISHABLE_KEY',
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  ),
  /** Chave pública do Cloudflare Turnstile. Vazia = captcha desligado (ex.: desenvolvimento). */
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '',
  /** URL pública do site, usada em links de e-mail e metadados. */
  siteUrl: (import.meta.env.VITE_SITE_URL || window.location.origin).replace(/\/$/, ''),
}
